




























































import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import MyMixin from "@/mixins/datemixin";

@Component({
  components: {},
})
export default class Configuration extends mixins(MobileMixin, MyMixin) {
  public items: any = [];
  public cause = false;
  public selectedMessage: any = {};

  public mounted() {
    this.$store.dispatch("config/getMessages").then((messages: any) => {
      messages.sort((m1: any, m2: any) => {
        return m1.horodatage > m2.horodatage ? 1 : -1;
      });

      this.items = messages;
      this.selectedMessage = this.items[0];
    });
  }

  public causeIt(message?: any) {
    this.selectedMessage = message;
  }
}
